import { Grid } from "@mui/system";
import LargestContentfulPaint from "./MetricsCharts/LargestContentfulPaint";
import InteractionNextPaint from "./MetricsCharts/InteractionNextPaint";
import TimeFirstByte from "./MetricsCharts/TimeFirstByte";
import FirstContentfulPaint from "./MetricsCharts/FirstContentfulPaint";

const PageSpeedMetrics = () => {
  return (
    <>
      <Grid container mt={0} columnSpacing={2}>
        <Grid size={6} mb={2}>
          <LargestContentfulPaint/>
        </Grid>
        <Grid size={6} mb={2}>
          <InteractionNextPaint/>
        </Grid>
        <Grid size={6}>
          <TimeFirstByte/>
        </Grid>
        <Grid size={6}>
          <FirstContentfulPaint/>
        </Grid>
      </Grid>
    </>
  );
};

export default PageSpeedMetrics;
